/* eslint-disable */
import ReportSalesAndProfitList from './report-sales-and-profit.list';

export default {
  // TODO: Temporarily use auto-render reports
  // list: ReportSalesAndProfitList,
};
